import LifenIllustration from '@assets/free-file.png';

import { EmptyState, Page } from '@honestica/ui-kit/src';
import { useTranslation } from 'react-i18next';

export const ForbiddenAccess = () => {
  const { t } = useTranslation();
  return (
    <Page.Empty>
      <EmptyState
        image={{ src: LifenIllustration }}
        title={t('error.forbiddenAccess.app_not_activated.title')}
        description={t('error.forbiddenAccess.app_not_activated.description')}
      />
    </Page.Empty>
  );
};
